import React from "react";
import {
  ApplicationsIcon,
  UserCheckIcon,
  CheckCircleIcon,
  FormsIcon,
  IdCardIcon,
  MedicalNotesIcon,
  LockIcon,
  DoctorIcon,
  CommentsIcon,
  BriefcaseIcon,
  SurveyorIcon,
  FileCheckIcon,
  PayrollIcon,
  RunningIcon,
} from "../Icons";

/**
 * Form Templates - Centralized metadata for all application forms
 * Each form has: id, title, icon, description, and styling
 */
export const FORM_TEMPLATES = {
  "application-form": {
    id: "application-form",
    title: "Application Form",
    icon: <ApplicationsIcon size={24} />,
    description: "Application Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "reference-request": {
    id: "reference-request",
    title: "Reference & Background Check",
    icon: <UserCheckIcon size={24} />,
    description: "Reference & Background Check",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "state-mandate": {
    id: "state-mandate",
    title: "State Mandate Compliance",
    icon: <CheckCircleIcon size={24} />,
    description: "State Mandate Compliance Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  handbook: {
    id: "handbook",
    title: "Handbook Form",
    icon: <FormsIcon size={24} />,
    description: "Employee Handbook Acknowledgment",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "employee-handbook-readonly": {
    id: "employee-handbook-readonly",
    title: "Employee Handbook",
    icon: <FormsIcon size={24} />,
    description: "Employee Handbook",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "caregiver-employee-handbook-readonly": {
    id: "caregiver-employee-handbook-readonly",
    title: "Employee Handbook",
    icon: <FormsIcon size={24} />,
    description: "Caregiver Employee Handbook (CG / CNA)",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "identification-card": {
    id: "identification-card",
    title: "Identification Card",
    icon: <IdCardIcon size={24} />,
    description: "Employee Identification Card Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  hepatitis: {
    id: "hepatitis",
    title: "Hepatitis Form",
    icon: <MedicalNotesIcon size={24} />,
    description: "Hepatitis B Vaccination Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  confidentiality: {
    id: "confidentiality",
    title: "Confidentiality Agreement",
    icon: <LockIcon size={24} />,
    description: "Confidentiality of Information Agreement",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "employment-agreement": {
    id: "employment-agreement",
    title: "Employment Agreement",
    icon: <FileCheckIcon size={24} />,
    description: "Employment Agreement",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "administrative-orientation": {
    id: "administrative-orientation",
    title: "Administrative Orientation",
    icon: <MedicalNotesIcon size={24} />,
    description: "Administrative Orientation Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "orientation-checklist": {
    id: "orientation-checklist",
    title: "Orientation Checklist",
    icon: <CheckCircleIcon size={24} />,
    description: "Orientation Checklist",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "tb-test": {
    id: "tb-test",
    title: "TB Test Form",
    icon: <RunningIcon size={24} />,
    description: "Tuberculosis Screening Questionnaire and PPD Record",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "flu-vaccination": {
    id: "flu-vaccination",
    title: "Flu Vaccination",
    icon: <RunningIcon size={24} />,
    description: "Flu Vaccination Consent / Declination Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "employee-health-examination": {
    id: "employee-health-examination",
    title: "Health Examination",
    icon: <DoctorIcon size={24} />,
    description: "Employee Health Examination Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "welcome-letter": {
    id: "welcome-letter",
    title: "Welcome Letter",
    icon: <CommentsIcon size={24} />,
    description: "Welcome Letter and Agreement",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  competency: {
    id: "competency",
    title: "Competency",
    icon: <CheckCircleIcon size={24} />,
    description: "Competency Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "job-description": {
    id: "job-description",
    title: "Job Description",
    icon: <BriefcaseIcon size={24} />,
    description: "Job Description Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "role-and-responsibility": {
    id: "role-and-responsibility",
    title: "Role and Responsibility",
    icon: <UserCheckIcon size={24} />,
    description: "Role and Responsibility Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "skill-inventory": {
    id: "skill-inventory",
    title: "Skill Inventory",
    icon: <SurveyorIcon size={24} />,
    description: "Skill Inventory Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "post-test": {
    id: "post-test",
    title: "Post-Test",
    icon: <FileCheckIcon size={24} />,
    description: "Post-Test Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "contractor-agreement": {
    id: "contractor-agreement",
    title: "Contractor Agreement",
    icon: <ApplicationsIcon size={24} />,
    description: "Services Agreement for Independent Contractors",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  w4: {
    id: "w4",
    title: "W-4 Form",
    icon: <PayrollIcon size={24} />,
    description: "Employee's Withholding Certificate",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  i9: {
    id: "i9",
    title: "I-9 Form",
    icon: <IdCardIcon size={24} />,
    description: "Employment Eligibility Verification",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  w9: {
    id: "w9",
    title: "W-9 Form",
    icon: <PayrollIcon size={24} />,
    description: "Request for Taxpayer Identification Number and Certification",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  de4: {
    id: "de4",
    title: "EDD (DE-4) Form",
    icon: <PayrollIcon size={24} />,
    description: "Employee's Withholding Allowance Certificate",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "direct-deposit-guide": {
    id: "direct-deposit-guide",
    title: "Direct Deposit",
    icon: <PayrollIcon size={24} />,
    description: "Direct Deposit Set-up Guide",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
  "chha-post-test": {
    id: "chha-post-test",
    title: "CHHA Post Test",
    icon: <RunningIcon size={24} />,
    description: "CHHA Post Test Form",
    color: "bg-indigo-50",
    textColor: "text-indigo-700",
    hoverColor: "hover:bg-indigo-100",
  },
};


/**
 * Position-specific form configurations
 * Maps position IDs to the forms they should see
 */
export const POSITION_FORMS = {
  rn: [
    "application-form",
    "reference-request",
    "welcome-letter",
    "confidentiality",
    "job-description",
    "state-mandate",
    "skill-inventory",
    "post-test",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "competency",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
  lvn: [
    "application-form",
    "reference-request",
    "welcome-letter",
    "confidentiality",
    "state-mandate",
    "job-description",
    "skill-inventory",
    "post-test",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "competency",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
  pt: [
    "application-form",
    "reference-request",
    "welcome-letter",
    "confidentiality",
    "state-mandate",
    "job-description",
    "role-and-responsibility",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "competency",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
  pta: [
    "application-form",
    "reference-request",
    "welcome-letter",
    "confidentiality",
    "state-mandate",
    "job-description",
    "role-and-responsibility",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "competency",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
  ot: [
    "application-form",
    "reference-request",
    "welcome-letter",
    "confidentiality",
    "state-mandate",
    "job-description",
    "role-and-responsibility",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "competency",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
  ota: [
    "application-form",
    "reference-request",
    "welcome-letter",
    "confidentiality",
    "state-mandate",
    "job-description",
    "role-and-responsibility",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "competency",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
  st: [
    "application-form",
    "reference-request",
    "welcome-letter",
    "confidentiality",
    "state-mandate",
    "job-description",
    "role-and-responsibility",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "competency",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
  hha: [
    "application-form",
    "reference-request",
    "welcome-letter",
    "confidentiality",
    "state-mandate",
    "job-description",
    "administrative-orientation",
    "chha-post-test",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "competency",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
  msw: [
    "application-form",
    "reference-request",
    "welcome-letter",
    "confidentiality",
    "state-mandate",
    "job-description",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "competency",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
  "office-assistant": [
    "application-form",
    "reference-request",
    "confidentiality",
    "state-mandate",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
  caregiver: [
    "application-form",
    "reference-request",
    "employment-agreement",
    "confidentiality",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "caregiver-employee-handbook-readonly",
  ],
  cna: [
    "application-form",
    "reference-request",
    "employment-agreement",
    "confidentiality",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "tb-test",
    "flu-vaccination",
    "employee-health-examination",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "caregiver-employee-handbook-readonly",
  ],
  con: [
    "contractor-agreement",
    "reference-request",
    "confidentiality",
    "state-mandate",
    "role-and-responsibility",
    "administrative-orientation",
    "handbook",
    "identification-card",
    "hepatitis",
    "orientation-checklist",
    "w4",
    "i9",
    "w9",
    "de4",
    "direct-deposit-guide",
    "employee-handbook-readonly",
  ],
};

/**
 * Get forms for a specific position
 * @param {string} positionId - The position identifier (e.g., 'rn', 'pt')
 * @param {string} positionName - The display name of the position (e.g., 'Registered Nurse (RN)')
 * @returns {Array} Array of form objects with metadata
 */
export const getFormsForPosition = (positionId, positionName) => {
  const formIds =
    POSITION_FORMS[positionId?.toLowerCase()] || POSITION_FORMS.rn;

  return formIds
    .map((formId) => {
      const template = FORM_TEMPLATES[formId];
      if (!template) {
        console.warn(`Form template not found for ID: ${formId}`);
        return null;
      }

      return {
        ...template,
        filename: `${positionName.toUpperCase()} ${template.title.toUpperCase()}.pdf`,
        description: `${positionName} ${template.description}`,
      };
    })
    .filter(Boolean);
};
